import React, {useMemo, useState} from "react";
import {Grid, Paper, Typography} from "@mui/material";
import DateFilter from "./core/DateFilter";
import Moment from "moment";
import SelectComponent from "./core/SelectComponent";
import InputComponent from "./core/InputComponent";
import SearchIcon from "@mui/icons-material/Search";
import {SmallLightTooltip} from "./core/Tooltip";
import {useEffect} from "react";
import moment from "moment";

function getAdjudicationStatus(metaData) {
    if (metaData && metaData.adjudicationStatusList) {
        return metaData.adjudicationStatusList.map((item, index) => {
            return {
                displayName: item,
                id: item
            };
        });
    } else {
        return [];
    }
}

function getReverseFeedStatus(metaData) {
    if (metaData && metaData.reverseFeedStatusList) {
        return metaData.reverseFeedStatusList.map((item, index) => {
            return {
                displayName: item,
                id: item
            };
        });
    } else {
        return [];
    }
}

function Search(props) {
    const {metaData} = props;
    const [dateSelected, setDateSelected] = useState({
        fromDate: Moment(new Date()).subtract(7, "days").format("YYYY-MM-DD"),
        toDate: Moment(new Date()).format("YYYY-MM-DD"),
    });
    // const [fromDate, setFromDate] = useState(
    //   Moment(new Date()).subtract(180, "days").format("YYYY-MM-DD")
    // );
    // const [toDate, setToDate] = useState(Moment(new Date()).format("YYYY-MM-DD"));
    const [dateType, setDateType] = useState();
    const [selectEntity, setSelectEntity] = useState("");
    const [searchValue, setSearchValue] = useState("");
    const menuList = [
        {
            displayName: "All",
            id: "ALL",
        },
        {
            displayName: "Patient Name",
            id: "PATIENT_NAME",
        },
        {
            displayName: "Hospital Name",
            id: "HOSPITAL_NAME",
        },
        {
            displayName: "Initimation Number",
            id: "INTIMATION_NUMBER",
        },
        {
            displayName: "Adjudication Status",
            id: "ADJUDICATION_STATUS",
        },
        {
            displayName: "Reverse Feed Status",
            id: "REVERSE_FEED_STATUS",
        },
    ];

    const valueList = selectEntity === 'ADJUDICATION_STATUS'
        ? getAdjudicationStatus(metaData)
        : selectEntity === 'REVERSE_FEED_STATUS'
            ? getReverseFeedStatus(metaData)
            : [];

    useEffect(() => {
        searchValue !== "" &&
        selectEntity !== "" &&
        searchValue.length >= 3 &&
        props.setSearchInfo({
            startDate: dateSelected.fromDate,
            endDate: dateSelected.toDate,
            attributesNames:
                typeof selectEntity === "object" ? selectEntity.id : selectEntity,
            attributeValue: searchValue,
            dateType: typeof dateType === "object" ? dateType.id : dateType,
        });
        searchValue === "" &&
        props.setSearchInfo({
            startDate: dateSelected.fromDate + "T00:00:00",
            endDate: dateSelected.toDate + "T23:59:59",
            attributesNames: "",
            attributeValue: "",
            dateType: typeof dateType === "object" ? dateType.id : dateType,
            // endDate: "2025-03-29T00:00:00",
        });
        // setSearchValue("");
    }, [searchValue]);

    useEffect(() => {
        selectEntity === "ALL" &&
        props.setSearchInfo({
            startDate: dateSelected.fromDate + "T00:00:00",
            endDate: dateSelected.toDate + "T23:59:59",
            attributesNames: "",
            attributeValue: "",
            dateType: typeof dateType === "object" ? dateType.id : dateType,
        });
    }, [selectEntity]);

    useEffect(() => {
        const fromDate = moment(dateSelected.fromDate, "YYYY-MM-DD");
        const toDate = moment(dateSelected.toDate, "YYYY-MM-DD");

        if (toDate.isBefore(fromDate)) {
            alert('The "toDate" is before the "fromDate"');
        } else {
            searchValue === "" &&
            props.setSearchInfo({
                startDate: dateSelected.fromDate + "T00:00:00",
                endDate: dateSelected.toDate + "T23:59:59",
                attributesNames: "",
                //typeof selectEntity === "object" ? selectEntity.id : selectEntity,
                attributeValue: "",
                dateType: typeof dateType === "object" ? dateType.id : dateType,
                // endDate: "2025-03-29T00:00:00",
            });

            searchValue !== "" &&
            props.setSearchInfo({
                startDate: dateSelected.fromDate,
                endDate: dateSelected.toDate,
                attributesNames:
                    typeof selectEntity === "object" ? selectEntity.id : selectEntity,
                attributeValue: searchValue,
                dateType: typeof dateType === "object" ? dateType.id : dateType,
            });
        }
    }, [dateSelected]);
    const handleDateChange = (date, field) => {
        const formattedDate = Moment(date).format("YYYY-MM-DD");
        field === "fromDate" &&
        setDateSelected({...dateSelected, fromDate: formattedDate});
        field === "toDate" &&
        setDateSelected({...dateSelected, toDate: formattedDate});
    };

    const handleSearchInput = (e) => {
        setSearchValue(e.target.value);
    };
    return (
        <Paper style={{width: "100%", padding: "10px 0"}}>
            <Grid
                container
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: 35,
                    padding: "0 10px",
                    width: "100%",
                }}
            >
                <Grid item style={{width: "250px", margin: "5px"}}>
                    <SelectComponent
                        menuItem={[
                            {id: "DATE_UPDATED", name: "Updated Date"},
                            {id: "DATE_CREATED", name: "Created Date"},
                        ]}
                        label={"Filter by"}
                        setSelections={setDateType}
                        selections={dateType}
                        mode="date"
                    />
                </Grid>

                <Grid
                    item
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: 10,
                    }}
                >
                    <Grid item>
                        <DateFilter
                            disableFuture={true}
                            fieldId={"fromDate"}
                            selectedDate={dateSelected.fromDate}
                            onDateChange={handleDateChange}
                        />
                    </Grid>

                    <Grid item>
                        <Typography variant="subtitle2" display="inline">
                            To
                        </Typography>
                        {/* <Typography variant='caption' display='inline'>
              {` (*Max 90 days)`}
            </Typography> */}
                    </Grid>
                    <Grid item>
                        <DateFilter
                            disableFuture={true}
                            fieldId={"toDate"}
                            selectedDate={dateSelected.toDate}
                            onDateChange={handleDateChange}
                        />
                    </Grid>
                </Grid>
                <Grid
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        gap: 10,
                    }}
                >
                    <Grid item style={{width: "250px", margin: "5px"}}>
                        <SelectComponent
                            menuItem={menuList}
                            label={"Entity to search"}
                            setSelections={setSelectEntity}
                            mode="entity"
                        />
                    </Grid>
                    {(selectEntity !== 'ADJUDICATION_STATUS' && selectEntity !== 'REVERSE_FEED_STATUS') &&
                        <SmallLightTooltip
                            title={
                                selectEntity !== null && Object.keys(selectEntity).length !== 0
                                    ? ""
                                    : `Select Entity Name`
                            }
                            placement="bottom"
                        >
                            <Grid item style={{width: "450px", marginTop: "20px"}}>
                                <InputComponent
                                    handleChange={handleSearchInput}
                                    icon={<SearchIcon/>}
                                    InputComponent="Search"
                                    disabled={
                                        selectEntity !== null &&
                                        Object.keys(selectEntity).length !== 0
                                            ? false
                                            : true
                                    }
                                    fullWidth={true}
                                />
                            </Grid>
                        </SmallLightTooltip>}
                    {(selectEntity === 'ADJUDICATION_STATUS' || selectEntity === 'REVERSE_FEED_STATUS') &&
                        <SmallLightTooltip
                            title={
                                selectEntity !== null && Object.keys(selectEntity).length !== 0
                                    ? ""
                                    : `Select Entity Name`
                            }
                            placement="bottom"
                        >
                            <Grid item style={{width: "450px", marginTop: "20px"}}>
                                <SelectComponent
                                    menuItem={valueList}
                                    label={"Entity to search"}
                                    setSelections={setSearchValue}
                                    mode="entity"
                                />
                            </Grid>
                        </SmallLightTooltip>}
                </Grid>
            </Grid>
        </Paper>
    );
}

export default Search;
